
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/polls",
      function () {
        return require("private-next-pages/polls.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/polls"])
      });
    }
  